
export const config = {
  showArtikelNumberField: true,
  showBrandField: false,
  tenantId: 'WILDLING',
};